import { initiateGoogleAuth } from '../services/googleAuthService';

const ConnectDriveModal = ({ isOpen, onClose }) => {
  const handleGoogleAuth = () => {
    console.log('Starting Google Auth...');
    initiateGoogleAuth();
  };

  return (
    <div className={`modal${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-content">
        <h2>Connect Drive</h2>
        <div className="drive-options">
          <button 
            className="drive-button"
            onClick={handleGoogleAuth}
          >
            Connect Google Drive
          </button>
          {/* More drive options can be added here */}
        </div>

        <button 
          className="close-button"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ConnectDriveModal; 